module.exports = __webpack_public_path__ + "img/PPT版_01.87e644ca.png";